import {Component, Vue} from 'vue-property-decorator'
import {ArrayHelpers} from "../common/ArrayHelpers";

@Component
class IsMeetingsEnabled extends Vue {
    static createMeetingButtonKey = 'createMeeting';

    buttonOptions = {
        [IsMeetingsEnabled.createMeetingButtonKey]: {
            enabled: true
        }
    };

    get isMeetingsEnabled(): boolean {
        return this.$store.getters['events/isMeetingsEnabled'];
    }

    get showCreateMeetingButton() {
        if (!this.$store.getters['events/allowMeetingWithSpeakers'] && this.isSpeaker) {
            return false;
        }
        if (this.buttonOptions && this.buttonOptions[IsMeetingsEnabled.createMeetingButtonKey]) {
            return this.buttonOptions[IsMeetingsEnabled.createMeetingButtonKey].enabled && this.isMeetingsEnabled;
        }
        return this.isMeetingsEnabled;
    }

    get isSpeaker() {
        return false;
    }

    get showCreateMeetingButtonToCurrentUser(): boolean {
        if (!this.showCreateMeetingButton) {
            return false;
        }

        const userGroupIds = this.$store.getters['groupIds'];
        const meetingsParams = this.$store.getters['events/selectedEventViewParam']('meetings', null);

        if (meetingsParams?.groupIds) {
            return !!ArrayHelpers.intersect(userGroupIds, meetingsParams?.groupIds).length;
        }

        return true;
    }

    get showPayButtonInsteadMeetings(): boolean {
        const payParams = this.$store.getters['events/selectedEventViewParam']('accessPayments', null);
        return !this.showCreateMeetingButtonToCurrentUser && !this.isSpeaker && payParams !== null;
    }
}

export {IsMeetingsEnabled}